/**
 * Cantonades de la reserva a la graella (en Pere, 29-SET-2026, sobre `plans/calendar-visual-refresh.md`):
 * arrodonides al dia d'entrada i al de sortida, rectes on la reserva continua fora del rang visible
 * (`clipStart`/`clipEnd`). Així, d'un cop d'ull, es veu si una reserva comença o acaba aquí.
 *
 * Senyals de la card (`plans/calendar-card-signals.md` D3, 30-SET): la vora dreta té radi propi,
 * recte per defecte, perquè hi van els tres llums. L'esquerra queda com era.
 *
 * Mòdul a part (i no a `calendar-theme.tsx`) perquè el fan servir el tema i la roda dentada, i el tema
 * ja importa la roda dentada.
 */

import type { CSSProperties } from 'react';

export type CardRadiusSetting = 'small' | 'medium' | 'large';

/** px de cada opció de la roda dentada (cantonades de l'esquerra). */
export const CARD_RADIUS_PX: Record<CardRadiusSetting, number> = {
  small: 4,
  medium: 8,
  large: 14,
};

/** Cantonades de la dreta (D3): Rectes 0 · Poc 4 · Rodones 14 px. */
export type RightRadiusSetting = 'square' | 'small' | 'round';

export const RIGHT_RADIUS_PX: Record<RightRadiusSetting, number> = {
  square: 0,
  small: 4,
  round: 14,
};

/**
 * `border-radius` d'una reserva: `left` a l'entrada i `right` a la sortida, 0 al costat tallat.
 * Serveix per a la card, l'anell de selecció, el marc d'estirar, la nansa i el fantasma d'arrossegar,
 * perquè tots casin.
 */
export function stayCornerStyle(
  left: number,
  right: number,
  stay: { clipStart?: boolean; clipEnd?: boolean }
): CSSProperties {
  const l = stay.clipStart ? 0 : left;
  const r = stay.clipEnd ? 0 : right;
  return {
    borderTopLeftRadius: l,
    borderBottomLeftRadius: l,
    borderTopRightRadius: r,
    borderBottomRightRadius: r,
  };
}
